export var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["RECORDING"] = "recording";
    RecordingStatus["SENT"] = "sent";
})(RecordingStatus || (RecordingStatus = {}));
//# sourceMappingURL=legacy-idb-types.js.map